import CloseIcon from "@mui/icons-material/Close";
import {
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import { t } from "i18next";
import { forwardRef, useImperativeHandle, useState } from "react";
import { CURRENCY } from "../../../constants/Variables";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing("24px"),
  },
  "& .MuiPaper-root": {
    width: "500px",
    [theme.breakpoints.down("sm")]: {
      margin: 12,
    },
  },
  "& .close-icon-btn": {
    position: "absolute",
    top: "5px",
    right: "5px",
  },
}));

const PricingDialog = forwardRef(({ showCloseBtn }, ref) => {
  const [open, setOpen] = useState(false);
  const [dialogData, setDialogData] = useState(null);

  useImperativeHandle(ref, () => ({
    openDialog(params) {
      setOpen(true);
      setDialogData(params);
    },
    closeDialog() {
      setOpen(false);
    },
  }));

  const handleClose = () => {
    setOpen(false);
  };

  console.log(dialogData, "dialogDatadialogDatadialogData");

  return (
    <BootstrapDialog
      onClose={handleClose}
      aria-labelledby="customized-dialog-title"
      open={open}
    >
      <IconButton className="close-icon-btn" onClick={handleClose}>
        <CloseIcon />
      </IconButton>

      <DialogTitle
        variant="h1"
        fontWeight={700}
        fontSize={"1.5rem"}
        fontFamily={"inter"}
        sx={{ m: 0, p: 2 }}
        id="customized-dialog-title"
      >
        {t("pricing")}
      </DialogTitle>
      <DialogContent dividers>
        <Box border={"1px solid grey"} borderRadius={1} overflow={"hidden"}>
          <Table aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell>{t("service")}</TableCell>
                <TableCell align="center">{t("price")}</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {dialogData?.data?.serviceSubCategoryId?.type === "area" && (
                <TableRow>
                  <TableCell>{t("perAreaCharges")}</TableCell>
                  <TableCell align="center">
                    {CURRENCY} {dialogData?.data?.price?.area || 0}
                  </TableCell>
                </TableRow>
              )}
              {dialogData?.data?.serviceSubCategoryId?.type === "fixed" && (
                <TableRow>
                  <TableCell>{t("serviceCharges")}</TableCell>
                  <TableCell align="center">
                    {CURRENCY} {dialogData?.data?.price?.fixed || 0}
                  </TableCell>
                </TableRow>
              )}
              {dialogData?.data?.serviceSubCategoryId?.type === "room+area" && (
                <>
                  <TableRow>
                    <TableCell>{t("perAreaCharges")}</TableCell>
                    <TableCell align="center">
                      {CURRENCY} {dialogData?.data?.price?.area || 0}
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>{t("perRoomCharges")}</TableCell>
                    <TableCell align="center">
                      {CURRENCY} {dialogData?.data?.price?.room || 0}
                    </TableCell>
                  </TableRow>
                </>
              )}
              {dialogData?.data?.serviceSubCategoryId?.type ===
                "interior+exterior" && (
                <>
                  <TableRow>
                    <TableCell>{t("interiorServiceCharges")}</TableCell>
                    <TableCell align="center">
                      {CURRENCY} {dialogData?.data?.price?.interior || 0}
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>{t("exteriorServiceCharges")}</TableCell>
                    <TableCell align="center">
                      {CURRENCY} {dialogData?.data?.price?.exterior || 0}
                    </TableCell>
                  </TableRow>
                </>
              )}
            </TableBody>
          </Table>
        </Box>
      </DialogContent>
    </BootstrapDialog>
  );
});

export default PricingDialog;
